module.exports = __webpack_public_path__ + "static/fipcwhitelambs2-82503ef43225363e82d12e3c0e01f1f8.jpeg";